import React, { useState } from "react";
import axios from "axios";


const usePunchManagementController = ({
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    const mainApi = `/cramSchool/api/class/management`
    const [data, setData] = useState([])

    const getPunchManagementData = ({
        cur_page,
        size,
        custom_filter_value,
        custom_filter_key,
        grade_class_id,
        date_start,
        date_end,
        only_date

    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: {
                cur_page,
                size,
                custom_filter_value,
                custom_filter_key,
                grade_class_id,
                date_start,
                date_end,
                only_date

            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }
                return {
                    ...data
                }
            });
    }
    //老師確認打卡
    const postPunchRecord = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/cramSchool/api/punch_record',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    //老師修改打卡
    const patchPunchRecord = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/cramSchool/api/punch_record',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    //行政確認打卡
    const postPunchRecordType = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/cramSchool/api/user_punch_record',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    //行政修改打卡
    const patchPunchRecordType = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/cramSchool/api/user_punch_record',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }

    const postSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/hrms/api/holiday/new_year',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )

                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }

            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        punchManagementDatas: data,
        getPunchManagementData,
        postPunchRecord,
        patchPunchRecord,
        postPunchRecordType,
        patchPunchRecordType
        // postSystemHolidaySettingData,
        // patchSystemHolidaySettingData,
        // deleteSystemHolidaySettingData,
    }
}
export { usePunchManagementController }
